import type { ResultHistoryCursor } from '../core/lottery/resultHistory';
import type { ResultLike } from '../core/rules/officialDrawResults';

export interface ResultHistoryPageCacheEntry {
  pages: ResultLike[][];
  cursor: ResultHistoryCursor | null;
  hasMore: boolean;
}

const store = new Map<string, ResultHistoryPageCacheEntry>();

export function readResultHistoryPageCache(
  key: string,
): ResultHistoryPageCacheEntry | null {
  return store.get(key) ?? null;
}

export function writeResultHistoryPageCache(
  key: string,
  entry: ResultHistoryPageCacheEntry,
): void {
  store.set(key, {
    pages: entry.pages,
    cursor: entry.cursor,
    hasMore: entry.hasMore,
  });
}

/** Test helper — not used in product UI. */
export function clearResultHistoryPageCache(): void {
  store.clear();
}
